import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareProductsAndServicesBlockData from '../../../Models/Content/SelfCareProductsAndServicesBlockData';
import ProductsAndServicesMain from './ProductsAndServicesMain';

export default class SelfCareProductsAndServicesBlock extends EpiComponent<SelfCareProductsAndServicesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <ProductsAndServicesMain iContent={this.props.data} context={this.getContext()} />;
  }
}
